import { render, staticRenderFns } from "./offline_order_list.vue?vue&type=template&id=6ccbb10c&scoped=true"
import script from "./offline_order_list.vue?vue&type=script&lang=js"
export * from "./offline_order_list.vue?vue&type=script&lang=js"
import style0 from "./offline_order_list.vue?vue&type=style&index=0&id=6ccbb10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbb10c",
  null
  
)

export default component.exports